import React from 'react';
import { Link } from 'site-modules/shared/components/link/link';

import './disclaimer-info.scss';

export function DisclaimerInfo() {
  return (
    <div className="medium">
      All reviews and comments to Edmunds are subject to the terms of our{' '}
      <Link className="terms-link" to="/about/visitor-agreement.html" target="_blank">
        Visitor Agreement
      </Link>
      .
    </div>
  );
}
